import { withRouteErrorListener } from '~/components/withRouteErrorListener'
import Index from '~/eligibility/eligibility'

export { loader } from '~/eligibility/eligibility/loader.server'
export { action } from '~/eligibility/eligibility/action.server'
export default withRouteErrorListener(Index)

//TODO: Make error boundary logic generic
export enum ErrorTypes {
  FAILED_TO_FETCH = 'Failed to fetch',
  LOAD_FAILED = 'Load failed',
}

export const ELIGIBILITY_TOAST = {
  MESSAGE: 'Please enter the data and try again',
  TITLE: 'We encountered an issue',
}

export const ELIGIBILITY_TOAST_TIMER = 1500
